import axios from "axios";
import ReactGA from 'react-ga';
const TRACKING_ID = "UA-190937912-3"; // YOUR_OWN_TRACKING_ID
ReactGA.initialize(TRACKING_ID);
ReactGA.pageview(window.location.pathname + window.location.search);

ReactGA.event({
  category: "Download",
  action: "User pressed the Download button",
});

ReactGA.exception({
  description: 'An error ocurred',
  fatal: true
});

const baseUrl = "https://8s2qyjli3k.execute-api.us-east-1.amazonaws.com/prod/transform";

function transform(data) {
  return axios.post(baseUrl, data);
}

export { transform };
